import { getCookie, getCurrentPage, getCurrentReactPage } from './es6/utils.js'

import { addPromotionalBanner_EVR_11952 } from './es6/promotionalBanner_EVR_11952.js'

if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, 'assign', {
        value: function assign(target, varArgs) {
            // .length of function is 2
            'use strict'
            if (target === null || target === undefined) {
                throw new TypeError('Cannot convert undefined or null to object')
            }

            var to = Object(target)

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index]

                if (nextSource !== null && nextSource !== undefined) {
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey]
                        }
                    }
                }
            }
            return to
        },
        writable: true,
        configurable: true,
    })
}

async function fetchUserInfo() {
    const requestOptions = {
        method: 'GET',
    }

    try {
        const res = await fetch('/bff/user/me', requestOptions)
        const resJSON = await res.json()

        return resJSON
    } catch (err) {
        console.log('failed to fetch user info: ', err)
        return {
            success: false,
        }
    }
}

export function extractFirstDate(str) {
    const match = str.match(/^\d{4}-\d{2}-\d{2}/)
    return match ? match[0] : null
}

export function isDateThreeDaysAgo(dateStr) {
    const inputDate = new Date(dateStr)
    const currentDate = new Date()
    const diffTime = currentDate - inputDate
    return diffTime >= 3 * 24 * 60 * 60 * 1000
}

export function isTwoMonthsOrMoreAgo(timestamp) {
    // Convert the input timestamp to a Date object
    const inputDate = new Date(timestamp * 1000) // Multiply by 1000 to convert seconds to milliseconds

    const currentDate = new Date()

    const twoMonthsAgo = new Date(currentDate)
    twoMonthsAgo.setMonth(currentDate.getMonth() - 2)

    return inputDate <= twoMonthsAgo
}

/* document.addEventListener('DOMContentLoaded', async () => {
    renderPromoBanner_EVR_11952()
})
 */

async function renderPromoBanner_EVR_11952() {
    const cookieName = 'hide_in_app_promo_banner_11952'
    const hasCookieSet = getCookie(cookieName)

    if (hasCookieSet) {
        return
    }

    const currentPage = getCurrentPage().length > 0 ? getCurrentPage() : getCurrentReactPage()

    const pagesToDisplayBanner = [
        'dashboard',
        'documents',
        'template',
        'contacts',
        'trash',
        'settings',
        'subscription',
        'billing',
        'developer',
        'signatures',
        'app_authorizations',
    ]

    // do not do any fetching if not on whitelisted page
    if (!pagesToDisplayBanner.includes(currentPage)) {
        return
    }

    // we need subscription id from current user
    const user = await fetchUserInfo()

    if (!user || !user.success) {
        console.log('cannot fetch user info')
        return
    }

    const userSubscriptionId = user.user_info.subscription_id
    const isNotTestUser = user.user_info.test_user !== 1
    const isFreeUser = userSubscriptionId === 47
    // This only shows the banner for users on the current basic plan:
    // const isBasicPlanUser = userSubscriptionId === 1355

    // This will show the banner for all users on a basic plan (including legacy basic plans)
    const isBasicPlanUser = user.user_info.subscription_plan_name === 'Basic'
    const isTrialUser = user.user_info.override_info === true
    const isNotTeamMember = user.user_info.is_business_owner

    // The banner is shown to all users on Trial, Free, or Basic plans (change from previous banner settings).
    if (
        pagesToDisplayBanner.includes(currentPage) &&
        (isTrialUser || isFreeUser || isBasicPlanUser) &&
        isNotTestUser &&
        isNotTeamMember
    ) {
        addPromotionalBanner_EVR_11952(cookieName)
    }
}
